import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { useEffect } from 'react';
import pusherChannelController from 'utils/pusher';

const { useChannel, createOrUpdate, destroy } = pusherChannelController;

const usePusher = () => {
  const { data } = useGetCurrentCustomerData();
  const userId = data?._id;

  useEffect(() => {
    if (!userId) return destroy();
    createOrUpdate(userId);
  }, [userId]);

  return useChannel();
};

export default usePusher;
